//@flow

import {useState, useCallback, useEffect} from 'react';
import {
  getCustomerComplaintSettingService,
  createOrEditCustomerComplaintSettingService,
} from '../promises';
import {useToastActions} from '../../toast-alert/utils';

import type {
  CustomerComplaintSettingResponse,
  CreateOrEditCustomerComplaintSettingRequest,
} from '../promises';

export function useCustomerComplaintSettings() {
  const [
    setting,
    setSetting,
  ] = useState<CustomerComplaintSettingResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [saving, setSaving] = useState<boolean>(false);
  const {showToast} = useToastActions();

  const loadSetting = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getCustomerComplaintSettingService();
      setSetting(response);
    } catch (exception) {
      console.error('Error loading customer complaint setting:', exception);
      if (exception?.status === 404) return;
      showToast({
        type: 'danger',
        title: 'Error al cargar la configuración de quejas',
        message: 'Ocurrió un error al cargar la configuración de quejas',
      });
    } finally {
      setLoading(false);
    }
  }, [showToast]);

  const saveSetting = useCallback(
    async (params: CreateOrEditCustomerComplaintSettingRequest) => {
      setSaving(true);
      try {
        const response = await createOrEditCustomerComplaintSettingService(
          params
        );
        setSetting(response);
        showToast({
          type: 'success',
          title: 'Configuración actualizada correctamente',
          message: 'Configuración actualizada correctamente',
        });
        return response;
      } catch (error) {
        console.error('Error saving customer complaint setting:', error);
        showToast({
          type: 'danger',
          title: 'Error al guardar la configuración de quejas',
          message: 'Error al guardar la configuración de quejas',
        });
        throw error;
      } finally {
        setSaving(false);
      }
    },
    [showToast]
  );

  useEffect(() => {
    loadSetting();
  }, [loadSetting]);

  return {
    setting,
    loading,
    saving,
    loadSetting,
    saveSetting,
  };
}
